/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserProvisionRequestListForm_viewer$ref: FragmentReference;
declare export opaque type UserProvisionRequestListForm_viewer$fragmentType: UserProvisionRequestListForm_viewer$ref;
export type UserProvisionRequestListForm_viewer = {|
  +id: string,
  +status: string,
  +clientAccount: ?{|
    +id: string,
    +name: ?string,
  |},
  +userModel: {|
    +id: string,
    +email: string,
    +userclientaccountroleSet: {|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +userRole: {|
            +id: string,
            +name: string,
          |}
        |}
      |}>
    |},
  |},
  +approvals: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +approvedBy: {|
          +id: string,
          +username: string,
        |},
        +approvedAt: any,
      |}
    |}>
  |},
  +hasCompleteApprovals: ?boolean,
  +$refType: UserProvisionRequestListForm_viewer$ref,
|};
export type UserProvisionRequestListForm_viewer$data = UserProvisionRequestListForm_viewer;
export type UserProvisionRequestListForm_viewer$key = {
  +$data?: UserProvisionRequestListForm_viewer$data,
  +$fragmentRefs: UserProvisionRequestListForm_viewer$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "UserProvisionRequestListForm_viewer",
  "type": "UserProvisionRequestNode",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "clientAccountId",
      "type": "ID"
    }
  ],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "clientAccount",
      "storageKey": null,
      "args": null,
      "concreteType": "ClientAccountNode",
      "plural": false,
      "selections": (v1/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "userModel",
      "storageKey": null,
      "args": null,
      "concreteType": "UserModelNode",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "userclientaccountroleSet",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "clientAccountId",
              "variableName": "clientAccountId"
            }
          ],
          "concreteType": "UserClientAccountRoleNodeConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "UserClientAccountRoleNodeEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserClientAccountRoleNode",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "userRole",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserRoleNode",
                      "plural": false,
                      "selections": (v1/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "approvals",
      "storageKey": null,
      "args": null,
      "concreteType": "ApprovalNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ApprovalNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ApprovalNode",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "approvedBy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserNode",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "username",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "approvedAt",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasCompleteApprovals",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f978e70cd3ca5e23184e096f7ba09d5d';
module.exports = node;
